import { IWheelProps } from '~/actions/extraHTML/wheelOfFortune';
import { notificationStyles } from '~/actions/extraHTML/wheelOfFortune/notificationStyles';
import { noRotationDesktopElementsStyles } from '~/actions/extraHTML/wheelOfFortune/styles/desktopStyles/noRotationDesktopElementsStyles';
import { notificationDesktopStyles } from '~/actions/extraHTML/wheelOfFortune/styles/desktopStyles/notificationDesktopStyles';
import { rotationDesktopElementStyles } from '~/actions/extraHTML/wheelOfFortune/styles/desktopStyles/rotationDesktopElementStyles';
import { wheelDesktopStyles } from '~/actions/extraHTML/wheelOfFortune/styles/desktopStyles/wheelDesktopStyles';
import {
  noRotationMobileElementsStyles
} from '~/actions/extraHTML/wheelOfFortune/styles/mobileStyles/noRotationMobileElementsStyles';
import { notificationMobileStyles } from '~/actions/extraHTML/wheelOfFortune/styles/mobileStyles/notificationMobileStyles';
import {
  rotationMobileElementStyles
} from '~/actions/extraHTML/wheelOfFortune/styles/mobileStyles/rotationMobileElementStyles';
import { rotationCss } from '~/actions/extraHTML/wheelOfFortune/styles/rotationStyles';
import { NotificationConfig } from '~/actions/triggers/types';


export const getCss = (iterator: number, prefix: string, wheelProps: IWheelProps, configuration?: NotificationConfig) => `

${notificationStyles(prefix, iterator)}
${rotationCss()}

${noRotationDesktopElementsStyles(prefix, wheelProps)}
${rotationDesktopElementStyles(prefix, wheelProps)}
${notificationDesktopStyles(iterator, prefix, configuration)}
${wheelDesktopStyles(iterator, prefix)}


${notificationMobileStyles(prefix, iterator, configuration)}
${noRotationMobileElementsStyles(prefix)}
${rotationMobileElementStyles(prefix, wheelProps)}
`;
